// Without options
// Vue.use(yourPlugin)
// With options
// Vue.use(yourPlugin, {
//     feedback: true,
//     control: true
// })

import { findModel, validatorFound } from './Utils/vnode'
import { ruleRunner, errorBagCreator } from './Core/RuleRunner'

const optionsDefault = {
  feedback: {
    valid: true,
    invalid: true
  },
  control: {
    valid: true,
    invalid: true
  }
}

export default {
  install (Vue, opts) {
    const options = { ...optionsDefault, ...opts }

    Vue.directive('taurus-validator', {
      // runs once, so this just setups the $validator obj on each decorated component
      // and is automatically not valid until tested
      bind (el, binding, vnode) {
        const validator = vnode.context.$validator
        // check if a validator exists if not create one (useful for multi checkboxs looped in a v-for for example)
        if (!validatorFound(vnode)) {
          const model = findModel(vnode)
          const validatorObj = {
            vmod: model.expression,
            value: model.value,
            compId: vnode.data.attrs.id ? vnode.data.attrs.id : vnode.elm.id.split('_')[0],
            valid: false,
            errorBag: errorBagCreator(binding.value.split('|')),
            tagName: el.tagName,
            vnode: vnode,
            rulesRan: false,
            fieldlabel: el.attributes.fieldlabel.nodeValue
          }
          validator.push(validatorObj)
        }
      },
      // Updates values in the $validator obj then sends the validator object to the rule runner
      // rule runner will then need to kick off the element update process and apply bs4 validation classes
      update (el, binding, vnode) {
        const validator = vnode.context.$validator // get validation array
        const model = findModel(vnode) // find current v-model
        const validatorObj = validator.find(d => d.vmod === model.expression) // filter array by v-model name
        // update the values
        validatorObj.value = model.value == null ? '' : model.value
        validatorObj.oldValue = model.oldValue == null ? '' : model.oldValue
        validatorObj.vnode = vnode
        
        // if value has changed check it --> run validatorObj off for testing,
        if (validatorObj.value !== validatorObj.oldValue) {
          ruleRunner(validatorObj, options)
        }
      },
      unbind (el, binding, vnode) {
        const validator = vnode.context.$validator // get validation array
        const model = findModel(vnode) // find current v-model
        const validatorObj = validator.find(d => d.vmod === model.expression) // filter array by v-model name
        // component removed so remove validation object
        vnode.context.$validator.splice(
          vnode.context.$validator.indexOf(validatorObj),
          1
        )
      }
    })
    Vue.mixin({
      beforeCreate () {
        this.$validator = [] // setup an array for for components
      },
      methods: {
        checkForm () {
          this.$validator.forEach(r => {
            ruleRunner(r, options)
          })
          return !this.$validator.some(e => e.valid === false)
        },
        checkFormIncChildren () {
          const runValidator = (obj) => {
            obj.$validator.forEach(r => {
              ruleRunner(r, options)
            })
            obj.$children.forEach(c => runValidator(c))
          }

          const checkValidator = (obj) => {
            const objValid = !obj.$validator.some(e => e.valid === false)
            if (objValid) {
              if (obj.$children && obj.$children.length > 0) {
                for (let idx = 0; idx < obj.$children.length; ++idx) {
                  const itm = obj.$children[idx]
                  const childValid = checkValidator(itm)
                  if (!childValid) {
                    return false
                  }
                }
              }
            }
            return objValid
          }

          runValidator(this)

          return checkValidator(this)
        },
        formErrors () {
          return this.$validator.filter(v => !v.valid)
        },
        resetFeedback () {
          this.$validator.forEach(function (r) {
            let feedback = document.getElementsByName(r.compId)[0]
            let control = document.getElementById(r.compId)
            feedback.innerText = ''
            if (feedback.classList.value.includes('d-block')) {
              feedback.classList.remove('d-block')
            }
            if (control.classList.value.includes('is-valid')) {
              control.classList.remove('is-valid')
            }
            if (control.classList.value.includes('is-invalid')) {
              control.classList.remove('is-invalid')
            }
          })
        }
      }
    })
  }
}
